import './styles/quasar.scss';
import lang from 'quasar/lang/sk.js';
import './assets/fonts/roboto-latin-ext.css';
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css';
import '@quasar/extras/fontawesome-v6/fontawesome-v6.css';
import AppFullscreen from 'quasar/src/plugins/AppFullscreen.js';import Cookies from 'quasar/src/plugins/Cookies.js';import Dialog from 'quasar/src/plugins/Dialog.js';import Meta from 'quasar/src/plugins/Meta.js';import Notify from 'quasar/src/plugins/Notify.js';import Loading from 'quasar/src/plugins/Loading.js';import LocalStorage from 'quasar/src/plugins/LocalStorage.js';;

// To be used on app.use(Quasar, { ... })
export default {
    config: {},
    plugins: { AppFullscreen, Cookies, Dialog, Meta, Notify, Loading, LocalStorage },
    lang: lang,
};
